import { render, staticRenderFns } from "./FooterBottom.vue?vue&type=template&id=76272532&scoped=true"
import script from "./FooterBottom.vue?vue&type=script&lang=js"
export * from "./FooterBottom.vue?vue&type=script&lang=js"
import style0 from "./FooterBottom.vue?vue&type=style&index=0&id=76272532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76272532",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoreOpeningHours: require('/app/components/StoreOpeningHours.vue').default,PaymentLogos: require('/app/components/PaymentLogos.vue').default,PaymentLegalNotices: require('/app/components/PaymentLegalNotices.vue').default})
